<template>
  <!-------------------- START - Mobile Menu -------------------->
  <div class="menu-mobile menu-activated-on-click nav-rain" style="background-color: #323c58;">
    <div class="mm-logo-buttons-w">
      <a class="mm-logo" href="/">
        <LogoComponent></LogoComponent>
        <b><span style="color: white;">OasisCloud</span></b>
      </a>
      <div class="mm-buttons">
        <div class="content-panel-open">
          <div class="os-icon os-icon-grid-circles"></div>
        </div>
        <div class="mobile-menu-trigger" @click="toggleMenu">
          <div class="os-icon os-icon-hamburger-menu-1 icon-transition"></div>
        </div>
      </div>
    </div>
    <div class="menu-and-user" style="color: white;">
      <div class="logged-user-w row">
        <i class="fas fa-user-circle" style="font-size: 30px;"></i>
        <div class="logged-user-info-w">
          <div class="logged-user-name" v-html="user.name || user.username"></div>
          <div class="logged-user-role" style="color: white;" v-html="user.email"></div>
        </div>
      </div>
      <!-------------------- START - Mobile Menu Tiles -------------------->
      <div class="hh-menu-tiles">
        <div class="row" v-if="!submenuActivo">
          <div class="col-6 mt-3 d-flex" v-for="currentMenu in modulosHH" v-bind:key="currentMenu.name"
            @click="seleccionarModulo(currentMenu)">
            <div class="buttons-group">
              <button type="button" class="c-button c-button--lg">
                <div class="icon-w" style="font-size: 2.5em">
                  <div :class="currentMenu.icon"></div>
                </div>
                <span style="font-size: 1.3em;" v-html="currentMenu.description"></span>
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <!-- Mismo estilo que "Ver todos los Requerimientos" -->
          <button type="button" class="btn btn-sm btn-info d-inline-flex align-items-center mt-3" @click="regresarMenu">
            <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
            <span class="ml-1">Regresar</span>
          </button>
          <div class="row">
            <div class="col-6 mt-3 d-flex" v-for="currentSubItem in itemsHH(submenuActivo)" v-bind:key="currentSubItem.name"
              @click="irA(currentSubItem)">
              <div class="buttons-group">
                <button type="button" class="c-button c-button--lg">
                  <div class="icon-w" style="font-size: 2.5em">
                    <div :class="currentSubItem.icon"></div>
                  </div>
                  <span style="font-size: 1.1em;" v-html="currentSubItem.description_hh || currentSubItem.description"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-------------------- END - Mobile Menu Tiles -------------------->
      <!-------------------- START - Mobile Menu List -------------------->
      <ul class="main-menu">
        <li>
          <router-link :to="'/'">
            <div class="icon-w">
              <div :class="'fas fa-layer-group'" style="font-size: 23px;"></div>
            </div>
            <span style="color: white;">Menú Principal</span>
          </router-link>
        </li>
        <li>
          <router-link :to="'/'">
            <div class="icon-w">
              <div :class="'fas fa-comments'" style="font-size: 23px;"></div>
            </div>
            <span style="color: white;">Buzón y Mensajes</span>
          </router-link>
        </li>
        <li>
          <router-link :to="'/'">
            <div class="icon-w">
              <div :class="'fas fa-bell'" style="font-size: 23px;"></div>
            </div>
            <span style="color: white;">Notificaciones</span>
          </router-link>
        </li>
        <li>
          <router-link :to="'/profile'">
            <div class="icon-w">
              <div :class="'fas fa-user-cog'" style="font-size: 23px;"></div>
            </div>
            <span style="color: white;">Configuraciones de Cuenta</span>
          </router-link>
        </li>
      </ul>
      <ul class="main-menu">
        <li>
          <a href="#" @click="logout">
            <div class="icon-w">
              <div :class="'fas fa-sign-out-alt'" style="font-size: 23px;"></div>
            </div>
            <span style="color: white;">Cerrar Sesión</span>
          </a>
        </li>
      </ul>
    </div>
  </div>

  <!-------------------- END - Mobile Menu -------------------->
</template>

<script>
import SideMenuUlComponent from "@/layouts/globals/SideMenuUlComponent.vue";
import LogoComponent from "@/components/LogoComponent.vue";
export default {
  components: {
    SideMenuUlComponent,
    LogoComponent
  },
  data() {
    return {
      user: {
        name: "",
        username: "",
        image: "",
        email: "",
      },
      submenuActivo: null,
    };
  },
  props: {},
  watch: {},
  computed: {
    module() {
      return this.$store.getters.module;
    },
    modules() {
      return this.$store.getters.modules;
    },
    modulosHH() {
      return (this.modules || []).filter((item) => item.show_in_hh);
    },
  },
  created() {
    this.user.name = localStorage.getItem("name");
    this.user.username = localStorage.getItem("username");
    this.user.email = localStorage.getItem("email");
    this.user.image = "http://localhost:8000" + localStorage.getItem("image");
  },
  mounted() {
    window.addEventListener("resize", this.ajustarPanelMenu);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.ajustarPanelMenu);
  },
  methods: {
    logout: function () {
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
      localStorage.removeItem("image");
      localStorage.removeItem("tipo_usuario");
      localStorage.removeItem("secciones_permitidas");
      localStorage.removeItem("vistas_permitidas");
      localStorage.removeItem("ocultar_checklist_info");
      this.$store.commit("SET_LAYOUT", "clean-layout");
      document.location.href = "/";
    },
    toggleMenu() {
      const menuIcon = $(".mobile-menu-trigger .os-icon");
      if (menuIcon.hasClass("os-icon-hamburger-menu-1")) {
        menuIcon.removeClass("os-icon-hamburger-menu-1").addClass("os-icon-close");
      } else {
        menuIcon.removeClass("os-icon-close").addClass("os-icon-hamburger-menu-1");
        this.submenuActivo = null;
      }
      this.ajustarPanelMenu();
      $(".menu-mobile .menu-and-user").slideToggle(200, "swing");
    },
    /**
     * El panel del menu se muestra encima de la pantalla (debajo de la barra superior)
     * y ocupa el resto del alto, con su propio scroll. Antes empujaba el contenido y
     * debajo se veia la pagina (en el inicio, los mismos recuadros repetidos).
     */
    ajustarPanelMenu() {
      const barra = document.querySelector(".menu-mobile .mm-logo-buttons-w");
      const panel = document.querySelector(".menu-mobile .menu-and-user");
      if (!barra || !panel) {
        return;
      }
      const arriba = Math.max(0, barra.getBoundingClientRect().bottom);
      panel.style.top = `${arriba}px`;
      panel.style.height = `${window.innerHeight - arriba}px`;
    },
    cerrarMenu() {
      const menuIcon = $(".mobile-menu-trigger .os-icon");
      menuIcon.removeClass("os-icon-close").addClass("os-icon-hamburger-menu-1");
      $(".menu-mobile .menu-and-user").slideUp(200, "swing");
      this.submenuActivo = null;
    },
    seleccionarModulo(currentMenu) {
      this.submenuActivo = currentMenu;
    },
    regresarMenu() {
      this.submenuActivo = null;
    },
    itemsHH(currentMenu) {
      return ((currentMenu && currentMenu.items) || []).filter(
        (item) => item.show_in_hh
      );
    },
    irA(currentSubItem) {
      this.cerrarMenu();
      // fullPath incluye el query (ej. ?tipo=requerimiento) para no repetir la misma ruta
      if (this.$route.fullPath !== currentSubItem.to) {
        this.$router.push(currentSubItem.to);
      }
    },
  },
};
</script>
<style>
.menu-mobile .menu-and-user {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 1035;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #323c58;
}
.hh-menu-tiles {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 0 12px 16px 12px;
  margin: 12px 0;
}
.icon-transition {
  transition: all 0.9s ease;
  opacity: 1;
}
/* Copos de nieve */
.emoji-fall {
    position: absolute;
    top: -10px;
    color: rgb(255, 255, 255);
    font-size: 1rem;
    user-select: none;
    pointer-events: none;
    opacity: 0.8;
    animation: fall linear infinite;
  }

  @keyframes fall {
    to {
      transform: translateY(6vh);
    }
  }
</style>